import { PropsComponent, PropsGeneral } from './../Data';
import { computePiecePrice, computeWeightWithDensity } from '../utils/helpers';
import {
  CROSS_PIECE_REINFORCEMENT_DATA1_FOR_WEIGHT,
  CROSS_PIECE_REINFORCEMENT_DATA2_FOR_WEIGHT,
  CROSS_PIECE_REINFORCEMENT_DEPTH_HEIGHT,
} from './../constants';
import { getPiecesProps } from '../utils/dataStorage';
export class CrossPieceReinforcement {
  readonly width: number;
  readonly custom: boolean;

  static _gapWidthToAddForReinforcement = -60;

  constructor(width: number, custom: boolean) {
    this.width = width;
    this.custom = custom;
  }

  get typeComponent() {
    return 'CrossPieceReinforcement';
  }

  get realHeight() {
    return CROSS_PIECE_REINFORCEMENT_DEPTH_HEIGHT;
  }

  get realWidth() {
    return this.width + CrossPieceReinforcement._gapWidthToAddForReinforcement;
  }

  get realDepth() {
    return CROSS_PIECE_REINFORCEMENT_DEPTH_HEIGHT;
  }

  static getProperties(): PropsComponent | void {
    return getPiecesProps().crossPiecesReinforcement;
  }

  static computeBasePrice(
    width: number,
    props: PropsComponent,
    propsGen: PropsGeneral,
  ) {
    /**
     * This formula came from the PRO100 Excel linked file
     *
     */
    const widthMicr = width / 1000;

    const k1 = props.k1 ?? 0;
    const k2 = props.k2 ?? 0;
    const k3 = props.k3 ?? 0;
    const k4 = props.k4 ?? 0;
    const k5 = props.k5 ?? 0;

    let price = ((widthMicr * k1 + k2) * k3 + k4) * k5;

    price *= propsGen.coef;
    price = Math.round(price * 100) / 100;

    return price;
  }

  public computePrice(): number {
    const props: PropsComponent | void = CrossPieceReinforcement.getProperties();
    const propsGen: PropsGeneral = getPiecesProps().general;

    if (!props) return 0;

    const priceForDimensions = CrossPieceReinforcement.computeBasePrice(
      this.realWidth,
      props,
      propsGen,
    );

    const priceForBase = CrossPieceReinforcement.computeBasePrice(
      this.realWidth,
      props,
      propsGen,
    );

    return computePiecePrice(
      priceForDimensions,
      priceForBase,
      this.custom,
      false,
      propsGen,
    );
  }

  public computeWeight(): number {
    const props: PropsComponent | void = CrossPieceReinforcement.getProperties();

    if (!props) return 0;

    return computeWeightWithDensity(
      this.realWidth,
      CROSS_PIECE_REINFORCEMENT_DATA1_FOR_WEIGHT,
      CROSS_PIECE_REINFORCEMENT_DATA2_FOR_WEIGHT,
      props.density,
    );
  }
}
